import { Fragment } from "react"
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import TextField from '@mui/material/TextField';
import { useTheme } from '@mui/material/styles';

const additionalInfoFieldRowSx = {
  display: "flex",
  alignItems: "center",
  gap: "12px",
  flexWrap: "wrap",
  marginBottom: "16px",
  "& > label": { flex: "0 0 200px", width: 200, minWidth: 200, margin: 0, whiteSpace: "nowrap", boxSizing: "border-box" },
  "& > div": { flex: "0 1 auto", minWidth: 0, maxWidth: 280 },
};
const formControlSx = (theme) => ({
  width: "100%",
  minWidth: 0,
  boxSizing: "border-box",
  [theme.breakpoints.up('md')]: { maxWidth: 280 },
});

const AdditionalInformation = ({
  feedbackRequired,
  handleFeedbackRequired,
  notificationTag,
  handleNotificationTag
}) => {
  const theme = useTheme();
  return (
    <Fragment>
      <label className="title" style={{fontSize: "14px", fontWeight: "bold"}}>Additional Information</label>
      <div className="content-block position-relative send-notification-additional" style={{ marginTop: "10px", overflow: "hidden", width: "100%", maxWidth: "100%", boxSizing: "border-box" }}>
        <div className="py-15">
          <Box sx={additionalInfoFieldRowSx} className="send-notification-field-row">
            <label className="title" style={{ color: 'black', fontSize: '14px'}}>Feedback Required</label>
            <div>
              <FormControlLabel
                control={
                  <Checkbox
                    checked = {feedbackRequired}
                    onChange={(e) => {
                      handleFeedbackRequired(e.target.checked)
                    }}
                    color="primary"
                  />
                }
                label={"Feedback Required"}
              />
            </div>
          </Box>
          <Box sx={additionalInfoFieldRowSx} className="send-notification-field-row">
            <label className="title" style={{ color: 'black', fontSize: '14px' }}>Notification Tag</label>
            <Box sx={formControlSx(theme)}>
              <TextField
                variant="standard"
                fullWidth
                style={{ height: '100px', padding: "10px", boxSizing: "border-box" }}
                placeholder="Enter Notification Tag"
                value={notificationTag}
                onChange={(e) => handleNotificationTag(e.target.value)}
                InputProps={{ disableUnderline: true }}
              />
            </Box>
          </Box>
        </div>
      </div>
    </Fragment>
  )
}

export default AdditionalInformation